import { render, staticRenderFns } from "./SlidesSection.vue?vue&type=template&id=4bebb49a&scoped=true&"
import script from "./SlidesSection.vue?vue&type=script&lang=js&"
export * from "./SlidesSection.vue?vue&type=script&lang=js&"
import style0 from "./SlidesSection.vue?vue&type=style&index=0&id=4bebb49a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bebb49a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
